<template>
  <progress max="100" min="0" :value="value" class="video-progress" />
</template>


<style lang="less" scoped>
progress.video-progress {
  /* Reset the default appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  display: block;

  background: black;
  color: #b11116;
  width: 100%;
  height: 5px;

  &::-webkit-progress-bar {
    background: #e1e1e1;
  }
  &::-webkit-progress-value {
    background: linear-gradient(90deg, #b11116, #ea3b40);
  }
  &::-moz-progress-bar {
    background: linear-gradient(90deg, #b11116, #ea3b40);
  }
}
</style>

<script>
export default {
  props: ["value"]
};
</script>


// WEBPACK FOOTER //
// src/public_app/pages/videozone/VideoProgress.vue